<template>
    <div class="webim-style-desc">
        <style-tab
            v-model="selectComponent"
            :options="[{value: 'link', text: '电脑端-链接型组件'}, {value: 'icon', text: '电脑端-图标型与DOM型组件'}, {value: 'mobile', text: '移动端'}]"
        />
        <div
            v-if="selectComponent === 'link'"
            class="desc-item desc-item--pc-normal"
        >
            <v-icon
                class="desc-item__preview"
                name="new_pc_normal"
            />
            <div
                :style="bgStyle.pc"
                class="desc-item__preview-bg"
            />
            <v-icon
                class="desc-item__preview-svg"
                name="new_pc_normal_bubble"
            />
            <div
                :style="colorStyle"
                class="desc-item__preview-bubble"
            />
            <div
                :style="colorStyle"
                class="desc-item__preview-button"
            />
        </div>
        <div
            v-else-if="selectComponent === 'icon'"
            class="desc-item desc-item--pc-simple"
        >
            <v-icon
                class="desc-item__preview"
                name="new_pc_simple"
            />
            <div
                :style="bgStyle.pc"
                class="desc-item__preview-bg"
            />
            <v-icon
                class="desc-item__preview-svg"
                name="new_pc_simple_bubble"
            />
            <div
                :style="colorStyle"
                class="desc-item__preview-bar"
            />
            <div
                :style="colorStyle"
                class="desc-item__preview-bubble"
            />
            <div
                :style="colorStyle"
                class="desc-item__preview-button"
            />
        </div>
        <div v-else>
            <div class="desc-item desc-item--mobile-normal">
                <v-icon
                    class="desc-item__preview"
                    name="new_mobile_normal"
                />
                <div
                    :style="bgStyle.mobile"
                    class="desc-item__preview-bg"
                />
                <v-icon
                    class="desc-item__preview-svg"
                    name="new_mobile_normal_bubble"
                />
                <div
                    :style="colorStyle"
                    class="desc-item__preview-bubble"
                />
                <div
                    :style="colorStyle"
                    class="desc-item__preview-button"
                />
            </div>
        </div>
    </div>
</template>

<script>
import StyleTab from '../../style-tab';
export default {
    components: { StyleTab },
    props: {
        colorStyle: {
            type: Object,
            default: () => {},
        },

        bgStyle: {
            type: Object,
            default: () => ({
                pc: {},
                mobile: {},
            }),
        },
    },
    data() {
        return {
            // 当前选择的是 链接组件还是图标型组件  link  icon
            selectComponent: 'link',
        };
    },

    watch: {
        selectComponent(newVal) {
            this.$emit('component-change', newVal);
        },
    },
};
</script>

<style lang="less">
@import '~@/common/common';

.webim-style-desc {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 480px;
    height: 426px;
    background: var(--color-bg-contrast);

    .desc-item {
        position: relative;
        display: inline-block;
        vertical-align: top;

        &__preview-svg {
            position: absolute;
            width: 148px;
            height: 32px;
        }

        &__preview-svg-text {
            position: absolute;
            width: 64px;
            height: 25px;
        }

        &__preview-bubble {
            position: absolute;
            width: 96px;
            height: 20px;
            border-radius: 3px;
        }

        &__preview-button {
            position: absolute;
            width: 30px;
            height: 16px;
            border-radius: 3px;
        }

        &__preview-bar {
            position: absolute;
            width: 140px;
            height: 21px;
            border-radius: 3px 3px 0 0;
        }

        &__preview-bg {
            position: absolute;
            background-position: center;
            background-size: cover;
        }

        &__preview {
            display: block;
            width: 440px;
            height: 326px;
        }

        &--pc-normal {
            .desc-item__preview-bubble {
                top: 116px;
                left: 184px;
            }

            .desc-item__preview-button {
                top: 258px;
                left: 250px;
            }

            .desc-item__preview-bg {
                top: 58px;
                left: 66px;
                width: 223px;
                height: 175px;
            }

            .desc-item__preview-svg {
                top: 71px;
                left: 72px;
            }

            .desc-item__preview-svg-text {
                top: 140px;
                left: 73px;
            }
        }

        &--pc-simple {
            .desc-item__preview-bar {
                top: 73px;
                left: 279px;
            }

            .desc-item__preview-bubble {
                top: 155px;
                left: 347px;
                width: 64px;
            }

            .desc-item__preview-button {
                top: 288px;
                left: 382px;
            }

            .desc-item__preview-bg {
                top: 94px;
                left: 279px;
                width: 140px;
                height: 168px;
            }

            .desc-item__preview-svg {
                top: 111px;
                left: 286px;
                width: 90px;
            }

            .desc-item__preview-svg-text {
                top: 176px;
                left: 257px;
            }
        }

        &--mobile-normal {
            .desc-item__preview {
                width: 158px;
                height: 324px;
            }

            .desc-item__preview-bubble {
                top: 96px;
                left: 76px;
                width: 70px;
            }

            .desc-item__preview-button {
                top: 280px;
                left: 114px;
            }

            .desc-item__preview-bg {
                top: 45px;
                left: 4px;
                width: 149px;
                height: 228px;
                background-color: #fff;
            }

            .desc-item__preview-svg {
                top: 54px;
                left: 10px;
                width: 88px;
                height: 32px;
            }

            .desc-item__preview-svg-text {
                top: 120px;
                width: 66px;
                height: 26px;
                left: 10px;
            }
        }
    }
}
</style>
